<template>
  <transition name="rich-picker-fade">
    <rich-popup ref="popup"
      type="picker"
      :mask="true"
      :center="false"
      :z-index="zIndex"
      v-show="isVisible"
      @touchmove.prevent
      @mask-click="maskClick">
      <transition name="rich-picker-move">
        <div class="rich-picker-panel" v-show="isVisible" @click.stop>
          <div class="rich-picker-choose">
            <span v-if="cancelIcon" class="rich-picker-cancel fusion-r_fusion_icon_closed" @click="cancel"></span>
            <div class="rich-picker-title-group">
              <h1 class="rich-picker-title" v-html="title"></h1>
              <h2 v-if="subtitle" class="rich-picker-subtitle" v-html="subtitle"></h2>
            </div>
          </div>

          <div class="rich-picker-content">
            <div class="rich-picker-checkbox-wrapper" ref="checkboxWrapper">
              <rich-checkbox-group v-model="currentCheckList" :options="options"></rich-checkbox-group>
            </div>
          </div>

          <div class="rich-picker-footer">
            <rich-button v-if="!btnGroup" @click="confirm">{{_confirmTxt}}</rich-button>
            <template v-if="btnGroup">
              <rich-button class="rich-picker-btn" :dark="true" :outline="true" @click="cancel">{{_cancelTxt}}</rich-button>
              <rich-button class="rich-picker-btn" :primary="true" @click="confirm">{{_confirmTxt}}</rich-button>
            </template>
          </div>
        </div>
      </transition>
    </rich-popup>
  </transition>
</template>

<script type="text/ecmascript-6">
import { i18n } from '@/common/utils/i18n'
import visibilityMixin from '@/mixins/visibility'
import popupMixin from '@/mixins/popup'
import basicPickerMixin from '@/mixins/basic-picker'
import pickerMixin from '@/mixins/picker'

const EVENT_SELECT = 'select'
const EVENT_VALUE_CHANGE = 'value-change'
const EVENT_CANCEL = 'cancel'
const EVENT_CHANGE = 'change'

export default {
  name: 'MultiSelectPicker',
  mixins: [visibilityMixin, popupMixin, basicPickerMixin, pickerMixin],
  props: {
    value: {
      required: true,
      type: Array,
      default: () => []
    },
    title: {
      required: false,
      type: String,
      default: i18n.gettext('请选择')
    },
    options: {
      required: true,
      type: Array,
      default: () => []
    },
    zIndex: {
      requried: false,
      type: Number,
      default: 50
    },
    btnGroup: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      finalData: this.data.slice(),
      currentCheckList: this.value.slice()
    }
  },
  methods: {
    show () {
      if (this.isVisible) {
        return
      }
      this.isVisible = true
    },
    hide () {
      if (!this.isVisible) {
        return
      }
      this.isVisible = false
    },
    maskClick () {
      this.maskClosable && this.cancel()
    },
    confirm () {
      this.hide()
      this.$emit(EVENT_SELECT, this.currentCheckList)
    },
    cancel () {
      this.hide()
      this.$emit(EVENT_CANCEL)
    }
  }
}
</script>

<style lang="scss" scoped>
.rich-picker-checkbox-wrapper {
  padding: 32px;
}
</style>
